import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { TopModuleDataObj, WVCustom, WVMain } from '../wallboard-view.model';
import { TopSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-top',
    templateUrl: './wallboard-view-custom-top.component.html',
    styleUrls: ['./wallboard-view-custom-top.component.scss']
})
export class WallboardViewCustomTopComponent implements OnInit, OnDestroy {
    @Input() index;
    @Input() height;
    @Input() width;
    @Input() firstSlide;

    public wvf: WVMain;
    public wvcf: WVCustom;
    public topState: TopSettingsTransferObj;
    public topData: TopModuleDataObj[] = [];
    public topMetricName: string = "";

    public slideError: boolean = false;
    public title: JQuery<HTMLElement>;
    public podium: JQuery<HTMLElement>;
    public name: JQuery<HTMLElement>;
    public value: JQuery<HTMLElement>;

    private updateTimerRef: NodeJS.Timeout = null;
    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }

    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;

        this._hasBackdrop = this.wvcf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";

        let moduleState = this.service.loadModuleState(ModuleType.Top, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.topState = response.topObj;
        });

        let topModuleData = this.service.getTopModuleData(this.wvcf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.topData = response;
        });

        this.service.getMetricName(this.wvcf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.topMetricName = response;
        });

        Promise.all([moduleState, topModuleData]).then(responses => {
            if (this.isDestroyed)
                return;

            this.title = $('.wvTopTitle');
            this.podium = $('.wvTopPodiumArea');
            this.name = $('.wvTopAgentName');
            this.value = $('.wvTopMetricValue');

            if (parseInt(this.height) + 34 > parseInt(this.width) || (this.height * 1.3875 > parseInt(this.width))) {
                this.title.css({ "font-size": Math.floor(this.width * 0.08) + "px" });
                this.podium.css({ "width": "100%", "height": (this.width / 2.3179) + "px" });
                this.name.css("font-size", this.width * 0.035 + "px");
                this.value.css("font-size", this.width * 0.045 + "px");
                this.podium.find(".wvTopPosition").css({ "width": this.podium.height() * 0.2 + "px", "height": this.podium.height() * 0.2 + "px", "top": "-" + this.podium.height() * 0.25 + "px" });
                this.podium.find(".wvTopData").css("top", "-" + this.podium.height() * 0.2 + "px");
            }
            else {
                this.title.css({ "font-size": parseInt(this.width) + 34 == $(window).width() && parseInt(this.height) + 34 == $(window).height() ? "5vw" : (Math.floor(this.height * 0.145) + "px") });
                this.podium.css("width", this.height * 1.3875 + "px");
                this.name.css("font-size", this.height * 0.05 + "px");
                this.value.css("font-size", this.height * 0.06 + "px");
                this.podium.find(".wvTopPosition").css({ "width": this.podium.width() * 0.1 + "px", "height": this.podium.width() * 0.1 + "px", "top": "-" + this.podium.width() * 0.125 + "px" });
                this.podium.find(".wvTopData").css("top", "-" + this.podium.width() * 0.1 + "px");
            }

            if (!this.updateTimerRef) {
                this.updateTimerRef = setInterval(() => {
                    this.service.getTopModuleData(this.wvcf.Slide.WallboardID, this.moduleKey).then(response => {
                        if (this.isDestroyed)
                            return;

                        this.topData = response;
                    });
                }, WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL);
            }

            if (!this.firstSlide) {
                let dup = false;
                for (let i = 0; i < this.wvcf.ReadyModules.length; i++) {
                    if (this.moduleKey == this.wvcf.ReadyModules[i]) {
                        dup = true;
                        break;
                    }
                }
                if (!dup)
                    this.wvcf.ReadyModules.push(this.moduleKey);
            }
        });
    }

    ngOnDestroy(): void {
        // End data updates
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    /**
     * Returns highest position specified podium is tied with, or itself if it is tied with nothing.
     * @param podium Podium to check tie status
     * @returns 1 if podium is tied with or is 1st, 2 if tied with or is 2nd, 3 if is 3rd and not tied, 0 if invalid podium given
     */
    getTiedPosition(podium): number {
        switch (podium) {
            case 1:
                return 1;
            case 2:
                if (this.topData[1] == undefined)
                    return 2;
                else if (this.topData[1].metricData.MetricValue == this.topData[0].metricData.MetricValue)
                    return 1;
                else
                    return 2;
            case 3:
                if (this.topData[2] == undefined)
                    return 3;
                else if (this.topData[2].metricData.MetricValue == this.topData[0].metricData.MetricValue)
                    return 1;
                else if (this.topData[2].metricData.MetricValue == this.topData[1].metricData.MetricValue)
                    return 2;
                else
                    return 3;
            default:
                return 0;
        }
    }

    getPodiumColor(podium) {
        switch (this.getTiedPosition(podium)) {
            case 1:
                return "#E6B400";
            case 2:
                return "#C0C0C0";
            case 3:
                return "#D17C00";
            default:
                return "";
        }
    }

    getPodiumClass(podium) {
        switch (this.getTiedPosition(podium)) {
            case 1:
                return "wvTopFirstPlace";
            case 2:
                return "wvTopSecondPlace";
            case 3:
                return "wvTopThirdPlace";
            default:
                return "";
        }
    }
}
